<template>
  <div id="Part02">
    <bg-video ref="bv" filename="Navigation" autoplay :class="{ blur }" @ended="isEnd = true"/>
    <img class="bg-text" src="./img/text.png" alt="bg-text">
    <nav-link filename="01" text="世界最长跨海大桥" :style="{ top: '1.8rem', left: '3.2rem' }" @click.native="$showFrame('http://newscenter.southcn.com/zt/20190902sjbri/index.html')"/>
    <nav-link filename="02" text="世界最长钢铁大桥" :style="{ top: '1.1rem', left: '6.5rem' }" @click.native="playVideo('gtdq')"/>
    <nav-link filename="03" text="世界最大钢圆筒" :style="{ top: '1.5rem', left: '11.7rem' }" @click.native="playVideo('gyt')"/>
    <nav-link filename="04" text="史上环保要求最高的交通工程" :style="{ top: '5.95rem', left: '3.1rem' }" @click.native="playVideo('bht')"/>
    <nav-link filename="05" text="最高防撞等级护栏" :style="{ top: '5.3rem', left: '5.9rem' }" @click.native="playVideo('hl')"/>
    <nav-link filename="06" text="世界最大单体钢桥面铺装" :style="{ top: '4.95rem', left: '8.8rem' }" @click.native="playVideo('qmpz')"/>
    <nav-link filename="07" text="世界首次实现沉管隧道滴水不漏" :style="{ top: '5.75rem', left: '12.1rem' }" @click.native="pv = !pv"/>
    <nav-link filename="08" text="世界最长海底沉管隧道" :style="{ top: '2.2rem', left: '14.12rem' }" @click.native="cv = !cv"/>
    <guide-button v-show="btnVisiable" class="btn-lt" @click="$router.push('/TitlePage/01')">返回</guide-button>
    <guide-button v-show="btnVisiable" class="btn-rt" @click="$router.push('/TitlePage/03')">继续</guide-button>
    <m-chart v-if="cv" @close="cv = !cv"/>
    <HSD v-if="pv" @close="pv = !pv"/>
  </div>
</template>

<script>
import mChart from '@/views/SubPage/mChart'
import HSD from '@/views/SubPage/HSD'
import images from '@/assets/worldlong/data'
export default {
  name: 'Part02',
  components: {
    mChart,
    HSD,
  },
  data () {
    return {
      blur: false,
      btnVisiable: false,
      isEnd: false,
      cv: false,
      pv: false,
      images,
    }
  },
  mounted () {
    this.$narrate.play('17', { auto: true }).then(_ => {
      this.btnVisiable = true
      this.$refs.bv.pause()
    })
  },
  methods: {
    playVideo (filename) {
      this.blur = true
      this.$narrate.pause()
      this.$refs.bv.pause()
      this.$vplayer.play({ url: filename }).then(_ => {
        this.blur = false
        if (!this.isEnd) {
          this.$refs.bv.play()
          this.$narrate.getInstance().audio.play()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 19.2rem;
  height: 10.8rem;
}
</style>
